@if (type === SelectType.Searchable || type === SelectType.AsyncSearchable) {
  <div #suggestion class="input-group fiori3-input-group fiori3-select-group" [class.info-shown]="infoMessage" [ngClass]="{ 'disabled-field': isDisabled }">
    @if (label && (label.key || label.value)) {
      <label [innerHTML]="label.value ? label.value : (label.key | translate)">
      </label>
    }
    @if (infoMessage) {
      <cpq-info  [customStyle]="customInfoStyle"  class="cpq-info-icon" [message]="infoMessage" (onInfoClick)="infoClicked()"></cpq-info>
    }
    <div class="input-frame">
      @if (!isDisabled) {
        @if (!query && iconType == IconType.Close) {
          <span class="search-icon sap-icon" (click)="suggest()"></span>
        }
        @if (query && iconType == IconType.Close) {
          <span class="close-icon sap-icon" (click)="deselect()"></span>
        }
        @if (iconType == IconType.Arrow) {
          <label for="{{id}}" class="cpq-select-sort-icons">
            @if (!showTooltip) {
              <span class="sap-icon">&#xe04e;</span>
            }
            @if (showTooltip) {
              <span class="sap-icon">&#xe04b;</span>
            }
          </label>
        }
      }
      <input cdkOverlayOrigin #suggestionOverlayOrigin="cdkOverlayOrigin" #cpqSelectInputField id="{{id ? id : name}}" autoComplete="off" [attr.tabindex]='tabindex' #field class="form-control search-bar" type="text" [(ngModel)]="query" (keyup)="navigate($event)"
        (keydown)="onKeyDown($event)" (focus)="suggest()" placeholder="{{label.placeholder | translatePlaceholder}}" (blur)="touched($event)"
        (click)='toggleActionMenu()'  (focusout)='onFocusOut($event)' [name]="name"
        focusOnLoad="focusOnLoad" [class.ng-valid]="control && control.valid"
        [class.ng-invalid]="control && !control.valid" [formControl]="searchControl" />
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="suggestionOverlayOrigin" [cdkConnectedOverlayOpen]="cdkOverlayOpened"
          [cdkConnectedOverlayPositions]="[{ originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' }]"
          [cdkConnectedOverlayWidth]="cdkOverlayWidth" (backdropClick)="cdkOverlayOpened = false">
          <ng-container #toltipDiv [style.display]="showTooltip ? 'block': 'none'">
            <!-- result -->
            @if (filteredList.length > 0 && !isDisabled) {
              <ul id="{{id ? id : name}}-cpq-select-items" class="cpq-select-suggestions-template"
                [ngClass]="dropdownListClass">
                <cdk-virtual-scroll-viewport [itemSize]='33'
                  [ngStyle]="{'height': filteredList.length <= 5 ? filteredList.length * 33 + 'px' : 165 + 'px'}"
                  [minBufferPx]="250" [maxBufferPx]="250" class="cpq-scroll">
                  <ng-container *cdkVirtualFor="let item of filteredList; let i = index">
                    <li [class.active]="i === navigationSelectedItemIndex" class="item" (click)="select(item, $event)"
                    title="{{item.text}}">{{item.text}}</li>
                  </ng-container>
                  <ng-container [ngTemplateOutlet]="createNewItemOptionTmp"></ng-container>
                </cdk-virtual-scroll-viewport>
              </ul>
            }
            <!-- No result -->
            @if (noSearchResults && filteredList.length === 0) {
              <ul id="{{id ? id : name}}-cpq-select-items" class="cpq-select-suggestions-template cpq-scroll no-results-select"
                [ngClass]="dropdownListClass">
                <li>
                  {{'Admin.Msg.NoResultsSearch' | translate}}
                </li>
                <ng-container [ngTemplateOutlet]="createNewItemOptionTmp"></ng-container>
              </ul>
            }
            <ng-template #createNewItemOptionTmp>
              @if (createNewItemOptions.visible) {
                <div class="create-new-item cpq-select-suggestions-template cpq-scroll"
                  [ngClass]="dropdownListClass">
                  <a id="{{id ? id : name}}-cpq-select-add-new-option" (click)='createNew()'>{{'Admin.SideMenu.AddNewChangeSet' | translate}}</a>
                </div>
              }
            </ng-template>
          </ng-container>
        </ng-template>
      </div>
      @if (control) {
        <show-errors [control]="control"></show-errors>
      }
    </div>
  }

  @if (type === SelectType.Simple) {
    <div class="input-group fiori3-input-group fiori3-select-group" [class.info-shown]="infoMessage">
      @if (label && (label.key || label.value)) {
        <label>
          {{label.value ? label.value : (label.key | translate)}}
        </label>
      }
      @if (infoMessage) {
        <cpq-info class="cpq-info-icon" [message]="infoMessage" (onInfoClick)="infoClicked()"></cpq-info>
      }
      @if (control) {
        <show-errors [control]="control"></show-errors>
      }
      <select [(ngModel)]="value" [name]='name' id="{{id ? id : name}}" [disabled]='isDisabled' [attr.tabindex]='tabindex'
        [class.ng-valid]="control && control.valid" [class.ng-invalid]="control && !control.valid">
        @if (showEmptySelection) {
          <option selected [value]=''></option>
        }
        @for (item of items; track (item?.id ?? item?.text)) {
          <option [ngValue]="item.id">{{item.text}}</option>
        }
      </select>
    </div>
  }
